export const getGstTypeName = (type) => {
    switch(type) {
      case 'GST': return 'SGST/CGST';
      case 'IGST': return 'IGST';
      case 'NOT APPLICABLE': return 'NOT APPLICABLE';
      case 'UGST': return 'UTGST';
      case 'SGST/CGST RCM': return 'SGST/CGST RCM';
      case 'IGST RCM': return 'IGST RCM';
      default: return type;
    }
  }
 export function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  export const getHumanReadableDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  }


// WEBPACK FOOTER //
// ./src/utils/globalUtils.js